import { themeGet } from 'styled-system';
import styled from 'react-emotion';

// @width
// @flex
export const CartWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: ${themeGet('colors.black')};
`;

// @width
// @flex
export const CartItem = styled('div')`
  display: flex;
  padding: ${themeGet('space.4')}px;
  align-items: stretch;
  background-color: ${themeGet('colors.greyLighter')};
  border-bottom: 1px solid ${themeGet('colors.greyLight')};
  opacity: ${props => (props.getsDeleted ? 0 : 1)};
  transition: opacity 0.2s linear;
`;

// @flex
// @box-shadow
export const QuantityManipulator = styled('span')`
  display: flex;
  align-items: stretch;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 0 0.25rem 0 hsla(0, 1%, 74%, 0.5);

  button {
    font-weight: 400;
    background-color: white;
    border: 0;
    outline: none;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    font-size: 20px;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
  }
`;

// @border
// @flex
// @padding
export const CartHeader = styled('header')`
  flex: 0 0 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid ${themeGet('colors.greyLight')};
  padding: 0 ${themeGet('space.4')}px;
`;

export const CartHeading = styled('h2')`
  font-size: 20px;
  font-weight: 400;
  color: ${themeGet('colors.blueDarker')};
`;

export const CartSubHeader = styled('span')`
  font-weight: 300;
  font-size: ${themeGet('fontSizes.2')}px;
  margin-left: ${themeGet('space.3')}px;
`;

export const CheckoutButton = styled('button')`
  background-color: ${themeGet('colors.red')};
  border: 0;
  padding: ${themeGet('space.2')}px;
  border-radius: ${themeGet('radii.default')}px;
  font-size: ${themeGet('fontSizes.2')}px;
  font-weight: 400;
  color: white;
`;

// @flex
export const DetailsContainer = styled('div')`
  flex: auto;
`;

// @flex
export const NameRow = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

// REF: Misc -> Subheading.
export const BrandRow = styled('h4')`
  font-weight: 300;
  margin-bottom: ${themeGet('space.4')}px;
`;

// @flex
export const QuantityRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Price = styled('span')`
  font-weight: 300;
`;

// REF: Misc -> Heading.
export const CartProductName = styled('h4')`
  font-weight: 400;
  color: ${themeGet('colors.blueDarker')};
`;

// @background-image
export const CartImage = styled('div')`
  background-image: url(${props => props.src});
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  background-color: white;
  border-radius: 4px;
  margin-right: ${themeGet('space.4')}px;
  flex: 0 0 80px;

  @media screen and (min-width: 40em) {
    margin-right: ${themeGet('space.5')}px;
  }

  @media screen and (min-width: 52em) {
    margin-right: ${themeGet('space.6')}px;
  }
`;

// @padding
export const SummaryContainer = styled('ul')`
  margin-top: ${themeGet('space.4')}px;
  padding: 0 ${themeGet('space.4')}px;
`;

// @flex
export const SummaryRow = styled('li')`
  font-weight: 300;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.sum {
    margin-top: ${themeGet('space.4')}px;
    font-weight: 400;

    + span {
      font-weight: 300;
    }
  }
`;

// @overflow
export const CartItemWrapper = styled('div')`
  overflow-y: scroll;
  -ms-overflow-style: none;
  overflow: auto;
  width: 100%;
  padding: 0 16px;
`;

export const DeleteButton = styled('button')`
  appearance: none;
  background-color: transparent;
  color: inherit;
  border: none;
  display: block;
  position: relative;
  overflow: hidden;
  width: 30px;
  height: 30px;
  cursor: pointer;
  outline: none;
  border-radius: 50%;
  transition: background-color 0.2s linear;

  &:hover {
    background-color: ${themeGet('colors.redLightest')};
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/cart/style.js